import { makeGenerateContent } from "../../list/logic/content";

export const generateContent = makeGenerateContent(true);
